import { MutableRefObject, useEffect, useRef } from "react";

/**
 *
 * @deprecated consider using useLoadMore from "@/utils/hooks/useLoadMore"
 *
 * @param callbackFunc
 * @returns
 */
const useLoadMore = (
  callbackFunc: <T>(entries: T) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): MutableRefObject<any> => {
  const ref = useRef(null);

  useEffect(() => {
    const target = ref.current;
    const options = {
      root: null, // window by default
      rootMargin: "0px",
      threshold: 0.75,
    };

    // Create observer
    const observer = new IntersectionObserver(callbackFunc, options);

    // observer of the referenced loader
    if (ref && target) {
      observer.observe(target);
    }

    // clean up on willUnMount
    return () => {
      if (!observer || !target) {
        return;
      }
      observer.unobserve(target);
    };
  }, [ref, callbackFunc]);

  return ref;
};

export default useLoadMore;
